var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tweet
    ? _c("div", { staticClass: "custom-tweet-display" }, [
        _c("div", { staticClass: "custom-tweet-display-header" }, [
          _c("div", { staticClass: "custom-tweet-display-name" }, [
            _vm._v(_vm._s(_vm.tweet.user.name))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "custom-tweet-display-screenname" }, [
            _vm._v("@" + _vm._s(_vm.tweet.user.screen_name))
          ])
        ]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.tweet.full_text))])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }